import { offer, money, getSelection, getDeliveryIntervals, prepareCart } from './thatmoo-offer.js?v=fc9d1493730bddf1';
import { createShopifyCheckout, resolveShopifyItem, shopifyRoutes, readShopifyCart,
  getShopifyCartView, removeShopifyOffer } from './thatmoo-shopify.js?v=fc9d1493730bddf1';

const $ = (selector, parent = document) => parent.querySelector(selector);
const $$ = (selector, parent = document) => [
  ...parent.querySelectorAll(selector),
];
const shopifyElement = $('#thatmoo-shopify');
const shopifyConfig = shopifyElement ? JSON.parse(shopifyElement.textContent) : null;
const checkoutSelection = shopifyConfig ? createShopifyCheckout(shopifyConfig) : null;
const assetElement = $('#thatmoo-assets');
if (assetElement) {
  const assets = JSON.parse(assetElement.textContent);
  const mapImages = (value) => {
    for (const [key, entry] of Object.entries(value)) {
      if (key === 'image' && assets[entry]) value[key] = assets[entry];
      else if (entry && typeof entry === 'object') mapImages(entry);
    }
  };
  mapImages(offer);
}
const purchaseLayout = offer.purchaseLayout === 'bundle-cards' ? 'bundle-cards' : 'size-first';
const purchaseControls = $('.purchase-controls');
if (purchaseLayout === 'bundle-cards') {
  purchaseControls.replaceChildren($('#purchase-layout-bundle-cards').content.cloneNode(true));
}
purchaseControls.dataset.layout = purchaseLayout;
const state = {
  packId: Object.keys(shopifyConfig?.packs || {}).find(id =>
    String(shopifyConfig.packs[id].variant?.id) === shopifyConfig.initialVariantId) || 'duo',
  purchaseType: 'subscription',
  interval: undefined,
  cart: null,
  checkingOut: false,
  cartLoading: false,
  cartError: '',
  cartCount: 0,
  fullCart: false,
};
let cartRevision = 0;
const cartDialog = $('#cart-dialog');
const guideDialog = $('#guide-dialog');
const sticky = $('.sticky-order');
const purchaseButton = $('.add-to-bag');
const dialogTriggers = new WeakMap();
const jars = (quantity) => `${quantity} ${quantity === 1 ? 'jar' : 'jars'}`;
const selection = () =>
  getSelection(state.packId, state.purchaseType, state.interval);
const setText = (selector, value, parent = document) => {
  $(selector, parent).textContent = value;
};
const textElement = (tag, text, className) => {
  const element = document.createElement(tag);
  element.textContent = text;
  if (className) element.className = className;
  return element;
};

function initAnnouncement() {
  const banner = $('.announcement');
  const message = $('.announcement-message', banner);
  const motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
  let lastWidth = 0;

  function buildLoop() {
    $('.announcement-viewport', banner)?.remove();
    banner.classList.remove('is-scrolling');
    if (motionPreference.matches) return;

    const viewport = document.createElement('div');
    viewport.className = 'announcement-viewport';
    viewport.setAttribute('aria-hidden', 'true');
    const track = document.createElement('div');
    track.className = 'announcement-track';
    const group = document.createElement('div');
    group.className = 'announcement-group';
    const item = message.cloneNode(true);
    item.classList.remove('announcement-message');
    group.append(item);
    track.append(group);
    viewport.append(track);
    banner.append(viewport);
    banner.classList.add('is-scrolling');

    // Each half fills the viewport so the repeated track never reveals a gap.
    const itemWidth = item.getBoundingClientRect().width;
    const copies = Math.ceil(banner.clientWidth / itemWidth);
    for (let i = 1; i < copies; i++) group.append(item.cloneNode(true));
    track.append(group.cloneNode(true));
    const distance = group.getBoundingClientRect().width;
    track.style.setProperty('--announcement-duration', `${distance / 28}s`);
  }

  motionPreference.addEventListener('change', buildLoop);
  new ResizeObserver(([entry]) => {
    if (entry.contentRect.width === lastWidth) return;
    lastWidth = entry.contentRect.width;
    buildLoop();
  }).observe(banner);
}

function renderOffer() {
  const selected = selection();
  const pack = offer.packs.find((pack) => pack.id === state.packId);
  const bundleThumbnail = $('[data-gallery="0"]');
  $('img', bundleThumbnail).src = pack.image;
  bundleThumbnail.setAttribute('aria-label', `View ${jars(pack.quantity)} bundle`);
  $('.sticky-product > img').src = pack.image;
  const oneTime = getSelection(state.packId, 'one-time');
  const recurring = getSelection(state.packId, 'subscription', state.interval);
  const isSubscription = state.purchaseType === 'subscription';

  setText('[data-subscription-reference]', money(oneTime.price));
  setText('[data-subscription-total]', money(recurring.price));
  setText('[data-onetime-total]', money(oneTime.price));
  if (purchaseLayout === 'size-first') {
    setText('[data-subscription-unit]', `${money(recurring.perJar)} / jar`);
    setText('[data-onetime-unit]', `${money(oneTime.perJar)} / jar`);
    setText('[data-subscription-saving]', `Save ${money(oneTime.price - recurring.price)} on every delivery`);
  } else {
    setText('.purchase-flexibility > span', isSubscription
      ? 'Skip, change or cancel before your next charge.'
      : 'One payment. No subscription or recurring charges.');
  }
  $('#subscribe').setAttribute(
    'aria-label',
    `Subscribe & save, ${money(recurring.price)} every ${recurring.intervalDays} days for ${jars(recurring.quantity)}`,
  );
  $('#one-time').setAttribute(
    'aria-label',
    `One-time purchase, ${money(oneTime.price)} for ${jars(oneTime.quantity)}`,
  );

  $$('input[name="purchase-type"]').forEach((input) => {
    input.checked = input.value === state.purchaseType;
    input.closest('label').classList.toggle('selected', input.checked);
    const method = input.closest('.purchase-method');
    if (method) {
      method.classList.toggle('selected', input.checked);
      $('.method-details', method).hidden = !input.checked;
    }
  });
  $$('input[name="pack"]').forEach((input) => {
    const quote = getSelection(input.value, state.purchaseType);
    const card = input.closest('label');
    input.checked = input.value === state.packId;
    input.setAttribute(
      'aria-label',
      `${jars(quote.quantity)}, ${quote.servings} servings${purchaseLayout === 'bundle-cards' ? `, ${money(quote.price)} total` : ''}`,
    );
    card.classList.toggle('selected', input.checked);
    if (purchaseLayout === 'bundle-cards') {
      setText('[data-pack-price]', money(quote.perJar), card);
      setText('.pack-total', `${money(quote.price)} total`, card);
      setText('.pack-saving', quote.savings > 0 ? `Save ${money(quote.savings)}` : 'Regular price', card);
    }
  });

  $$('[data-bind="price"]').forEach((element) => {
    element.textContent = money(selected.price);
  });

  $('.bonus-panel').classList.toggle('bonus-locked', !selected.bonusEligible);
  setText(
    '.bonus-copy > strong',
    selected.bonusEligible
      ? '3 FREE digital guides'
      : 'Unlock 3 free guides',
  );
  setText(
    '.bonus-copy > p',
    selected.bonusEligible
      ? (isSubscription
        ? 'Included with your first subscription delivery. Yours to keep.'
        : 'Included with this order. Digital downloads, yours to keep.')
      : 'Choose 2 or 3 jars to get all 3 digital guides.',
  );
  $('.bonus-copy > a').hidden = !selected.bonusEligible;
  const upgrade = $('[data-action="upgrade-duo"]');
  upgrade.hidden = selected.bonusEligible;
  upgrade.textContent = `Upgrade to 2 jars · +${money(getSelection('duo', state.purchaseType).price - selected.price)} →`;
  $('.delivery-select').hidden = !isSubscription;
  $('#delivery').disabled = !isSubscription;
  $('#delivery').replaceChildren(...getDeliveryIntervals(state.packId).map((days) => {
    const option = document.createElement('option');
    option.value = String(days);
    option.textContent = days === 28 ? 'month' : `${days / 28} months`;
    option.selected = days === selected.intervalDays;
    return option;
  }));

  const contents = `${jars(selected.quantity)}${selected.bonusEligible ? ' + 3 free guides' : ''}`;
  setText(
    '.order-summary > span',
    selected.bonusEligible ? contents : `${contents} of colostrum powder`,
  );
  setText('.order-summary > strong', `About ${money(selected.perServing)} / serving`);
  const renewal = textElement(
    'strong',
    isSubscription
      ? `${money(selected.price)} today, then every ${selected.intervalDays} days for ${jars(selected.quantity)}.`
      : `${money(selected.price)} today.`,
  );
  $('.renewal-note').replaceChildren(
    renewal,
    document.createTextNode(
      isSubscription
        ? ' Skip, change or cancel before your next charge.'
        : ' One payment. No subscription.',
    ),
  );

  setText('.comparison-label', `YOUR ${selected.quantity}-JAR BUNDLE`);
  setText(
    '.comparison-row:not(.subscription-row) > strong',
    money(oneTime.price),
  );
  setText('.subscription-row > strong', money(recurring.price));
  setText('.subscription-row small', `Every ${recurring.intervalDays} days`);
  const saving = $('.comparison-saving');
  saving.replaceChildren(
    saving.querySelector('svg'),
    document.createTextNode(
      ` ${money(oneTime.price - recurring.price)} less per delivery`,
    ),
  );

  setText('.sticky-name > strong', contents);
  setText(
    '.sticky-name > span',
    isSubscription
      ? `${money(selected.price)} every ${selected.intervalDays} days · Subscribe & Save`
      : 'One-time purchase · no refills',
  );
  const stickyButton = $('.sticky-action .primary-button');
  const arrow = stickyButton.querySelector('svg');
  stickyButton.replaceChildren(
    document.createTextNode(`Add to bag · ${money(selected.price)} `),
    arrow,
  );
  if (shopifyConfig && !shopifyConfig.enabled) {
    $$('[data-action="add-to-bag"]').forEach(button => {
      button.disabled = true;
      button.textContent = 'Ordering opens soon';
    });
  }
  scheduleSticky();
}

function changePack(packId) {
  state.packId = packId;
  state.interval = undefined;
  renderOffer();
  changeGallery(0, undefined, { animate: false });
}

function renderReviews() {
  const section = $('#reviews');
  if (!section) return;
  const isCompleteReview = (review) =>
    typeof review.name === 'string' && review.name.trim() &&
    typeof review.title === 'string' && review.title.trim() &&
    typeof review.body === 'string' && review.body.trim();
  const customerReviews = offer.reviews.filter(isCompleteReview);
  const isSample = customerReviews.length === 0;
  const reviews = isSample ? offer.reviewSamples.filter(isCompleteReview) : customerReviews;
  if (!reviews.length) return;

  const template = $('.review-card', section);
  const cards = reviews.map((review) => {
    const card = template.cloneNode(true);
    card.classList.remove('review-placeholder');
    setText('h3', review.title, card);
    setText('.review-body', review.body, card);
    setText('.review-name', review.name, card);
    const context = $('.review-context', card);
    context.hidden = isSample;
    context.textContent = isSample ? '' : review.context || 'ThatMoo Colostrum Powder';
    const initials = review.name.trim().split(/\s+/).slice(0, 2).map((part) => part[0]).join('').toUpperCase();
    setText('.review-avatar', initials, card);

    const stars = $('.review-stars', card);
    const hasRating = Number.isInteger(review.rating) && review.rating >= 1 && review.rating <= 5;
    stars.hidden = !hasRating;
    if (hasRating) {
      stars.textContent = '★'.repeat(review.rating) + '☆'.repeat(5 - review.rating);
      stars.removeAttribute('aria-hidden');
      stars.setAttribute('role', 'img');
      stars.setAttribute('aria-label', `${isSample ? 'Sample rating: ' : ''}${review.rating} out of 5 stars`);
    }
    return card;
  });
  $('.reviews-grid', section).replaceChildren(...cards);
  section.dataset.mode = isSample ? 'sample' : 'reviews';
  if (isSample) return;
  $('.reviews-preview-note', section).hidden = true;
  const summary = $('.reviews-summary', section);
  summary.hidden = false;
  const ratings = reviews.filter((review) => Number.isInteger(review.rating) && review.rating >= 1 && review.rating <= 5);
  summary.textContent = `${reviews.length} ${reviews.length === 1 ? 'review' : 'reviews'}`;
  if (ratings.length) {
    const average = ratings.reduce((sum, review) => sum + review.rating, 0) / ratings.length;
    summary.textContent += ` · ${average.toFixed(1)} / 5 from ${ratings.length} ${ratings.length === 1 ? 'rating' : 'ratings'}`;
  }
}

function renderCart() {
  const cart = state.cart;
  const waiting = state.cartLoading || state.checkingOut;
  $('.cart-body').hidden = !cart || state.fullCart || Boolean(state.cartError) || waiting;
  $('.cart-empty-action').hidden = Boolean(cart) || state.fullCart || Boolean(state.cartError) || waiting;
  setText('#cart-title', cart || state.fullCart || state.cartError || waiting ? 'Your bag' : 'Your bag is empty');
  setText(
    '#cart-description',
    waiting ? 'Checking your saved bag…' : state.fullCart
      ? 'Your bag has other items or changes. Review the full bag for current quantities and prices.' : cart
      ? (shopifyConfig ? 'Review your selection before secure checkout.' : 'Review your selection. This is a local order preview.')
      : (shopifyConfig ? 'Choose your bundle to get started.' : 'Choose your bundle to preview your order.'),
  );
  $('.bag-button').setAttribute(
    'aria-label',
    `Open bag, ${shopifyConfig ? state.cartCount : cart?.quantity || 0} items`,
  );
  setText('.bag-button > span', shopifyConfig ? state.cartCount : cart?.quantity || 0);
  const status = $('.cart-status');
  status.hidden = !state.cartError;
  status.textContent = state.cartError;
  const fullCartLink = $('.cart-review-link');
  fullCartLink.hidden = !shopifyConfig || waiting || !(state.fullCart || state.cartError);
  if (shopifyConfig) fullCartLink.href = shopifyRoutes(shopifyConfig).cart;
  const checkoutButton = $('.checkout-unavailable');
  if (shopifyConfig) {
    checkoutButton.dataset.action = 'checkout';
    checkoutButton.disabled = true;
    checkoutButton.textContent = state.checkingOut ? 'Checking your bag…' : 'Checkout';
    let message = '';
    try {
      if (cart) {
        resolveShopifyItem(cart, shopifyConfig);
        checkoutButton.disabled = waiting;
      }
    } catch (error) { message = error.message; }
    setText('.cart-preview-note', message || 'Shipping and any applicable taxes are confirmed at checkout.');
  }
  if (!cart) return;
  const pack = offer.packs.find((pack) => pack.id === cart.packId);
  $('.cart-product > img').src = pack.image;
  $('.cart-product > img').alt = pack.imageAlt;
  setText('.cart-product > div > strong', offer.product);
  setText(
    '.cart-product > div > span',
    `${jars(cart.quantity)} · ${cart.name}`,
  );
  setText(
    '.cart-product small',
    cart.purchaseType === 'subscription'
      ? `Subscribe & Save · every ${cart.intervalDays} days`
      : 'One-time purchase',
  );
  setText('.cart-product > strong', money(cart.price));
  $('.cart-bonus').hidden = !cart.bonusEligible;
  setText('.cart-summary > strong', `${money(cart.price)} ${offer.currency}`);
  setText(
    '.cart-terms',
    (shopifyConfig
      ? 'Contiguous-US shipping included. Any applicable taxes are calculated at checkout.'
      : 'Contiguous-US shipping included. Taxes are not calculated in this preview.') +
      (cart.purchaseType === 'subscription'
        ? ` Refills: ${jars(cart.quantity)} for ${money(cart.price)} every ${cart.intervalDays} days. Skip, change or cancel before your next charge.`
        : ' No recurring charge.'),
  );
}

function applySavedCart(cart) {
  const view = getShopifyCartView(cart, shopifyConfig);
  state.cart = view.selection;
  state.cartCount = view.count;
  state.fullCart = view.requiresFullCart;
}

async function refreshCart() {
  if (!shopifyConfig || state.checkingOut) return;
  const revision = ++cartRevision;
  state.cartLoading = true;
  state.cartError = '';
  renderCart();
  try {
    const cart = await readShopifyCart(shopifyConfig);
    if (revision === cartRevision) applySavedCart(cart);
  } catch (error) {
    if (revision === cartRevision) state.cartError = error.message;
  } finally {
    if (revision === cartRevision) {
      state.cartLoading = false;
      renderCart();
    }
  }
}

async function updateSavedCart(action, selected, trigger) {
  if (!checkoutSelection || state.checkingOut) return;
  ++cartRevision; // An older background read must not replace this mutation.
  state.cartLoading = false;
  state.cartError = '';
  state.checkingOut = true;
  renderCart();
  if (trigger) openDialog(cartDialog, trigger);
  const unlocked = $$('[data-action="add-to-bag"], [data-action="remove-from-bag"], [data-action="checkout"], .purchase-controls input, .purchase-controls select')
    .filter(control => !control.disabled);
  unlocked.forEach((control) => { control.disabled = true; });
  const unlock = () => {
    unlocked.forEach((control) => { control.disabled = false; });
    state.checkingOut = false;
    renderCart();
  };
  try {
    if (action === 'checkout') {
      const cart = await readShopifyCart(shopifyConfig);
      const current = getShopifyCartView(cart, shopifyConfig);
      applySavedCart(cart);
      if (!current.selection || ['packId', 'purchaseType', 'intervalDays', 'price']
        .some(key => current.selection[key] !== selected[key])) {
        if (current.requiresFullCart) {
          unlock();
          window.location.assign(shopifyRoutes(shopifyConfig).cart);
          return;
        }
        throw new Error('Your bag changed. Review the current selection before continuing.');
      }
    }
    const result = action === 'remove'
      ? { cart: await removeShopifyOffer(shopifyConfig) }
      : await checkoutSelection(selected);
    applySavedCart(result.cart);
    unlock(); // Keep controls usable when returning via the browser's back cache.
    if (action === 'checkout') window.location.assign(result.url);
    else if (action === 'remove' && !state.fullCart && cartDialog.open) $('.cart-empty-action').focus();
  } catch (error) {
    state.cartError = error.message;
    unlock();
  }
}

function openDialog(dialog, trigger) {
  if (dialog.open) return;
  dialogTriggers.set(dialog, trigger || document.activeElement);
  dialog.showModal();
  updateSticky();
}

function closeDialogs() {
  $$('dialog[open]').forEach((dialog) => dialog.close());
}

function returnToOffer() {
  closeDialogs();
  $('#purchase-options').scrollIntoView({
    block: 'start',
    behavior: matchMedia('(prefers-reduced-motion: reduce)').matches
      ? 'instant'
      : 'smooth',
  });
}

function openGuide(index, trigger) {
  const guide = offer.guides[index];
  if (!guide) return;
  const image = $('.guide-preview-image');
  image.src = guide.image;
  image.alt = `ThatMoo book mockup of ${guide.shortTitle}; digital guide`;
  setText('#guide-title', guide.shortTitle);
  setText('#guide-description', guide.title);
  setText('.guide-detail', guide.description);
  openDialog(guideDialog, trigger);
}

const hero = $('.hero-photo');
const heroSlide = $('.gallery-slide', hero);
const heroImage = $('#gallery-image');
const galleryButtons = $$('[data-gallery]');
const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
const galleryImages = new Map();
let galleryIndex = 0;
let displayedGalleryIndex = 0;
let gallerySource = heroImage.getAttribute('src');
let displayedGallerySource = gallerySource;
let galleryRequest = 0;
let galleryTransition = Promise.resolve();
let galleryAnimations = [];

function markGallerySelection() {
  galleryButtons.forEach((button) => {
    const active = Number(button.dataset.gallery) === galleryIndex;
    button.classList.toggle('active', active);
    button.setAttribute('aria-pressed', String(active));
  });
}

function galleryItem(index) {
  const item = offer.productImages[index];
  if (item?.kind !== 'bundle') return item;
  const pack = offer.packs.find((pack) => pack.id === state.packId);
  return { ...item, image: pack.image, alt: pack.imageAlt };
}

function loadGalleryImage(source) {
  if (!galleryImages.has(source)) {
    const image = new Image();
    image.src = source;
    galleryImages.set(source, image.decode().then(() => image).catch((error) => {
      galleryImages.delete(source);
      throw error;
    }));
  }
  return galleryImages.get(source);
}

async function changeGallery(index, direction, { animate = true } = {}) {
  const item = galleryItem(index);
  if (!item || (index === galleryIndex && item.image === gallerySource)) return;
  const request = ++galleryRequest;
  galleryIndex = index;
  gallerySource = item.image;
  markGallerySelection();

  // Quantity changes replace the product photo without sliding. Settle any
  // gallery movement already underway before showing the newly decoded pack.
  if (!animate) galleryAnimations.forEach((animation) => animation.finish());

  // Keep the current photo visible until the next one is decoded. Finish any
  // slide already in motion, then honour the latest click without snapping.
  try {
    await Promise.all([loadGalleryImage(item.image), galleryTransition]);
  } catch {
    if (request === galleryRequest) {
      galleryIndex = displayedGalleryIndex;
      gallerySource = displayedGallerySource;
      markGallerySelection();
    }
    return;
  }
  if (request !== galleryRequest || (index === displayedGalleryIndex && item.image === displayedGallerySource)) return;
  direction ??= Math.sign(index - displayedGalleryIndex) || 1;

  const outgoing = heroSlide.cloneNode(true);
  outgoing.setAttribute('aria-hidden', 'true');
  outgoing.querySelector('img').removeAttribute('id');
  hero.dataset.kind = item.kind;
  heroSlide.dataset.kind = item.kind;
  heroImage.src = item.image;
  heroImage.alt = item.alt;
  displayedGalleryIndex = index;
  displayedGallerySource = item.image;

  if (animate && !reducedMotion.matches) {
    heroSlide.after(outgoing);
    hero.classList.add('is-sliding');
    const timing = { duration: 440, easing: 'cubic-bezier(.22,.61,.36,1)', fill: 'both' };
    const animations = [
      outgoing.animate([
        { transform: 'translate3d(0,0,0)' },
        { transform: `translate3d(${-direction * 100}%,0,0)` },
      ], timing),
      heroSlide.animate([
        { transform: `translate3d(${direction * 100}%,0,0)` },
        { transform: 'translate3d(0,0,0)' },
      ], timing),
    ];
    galleryAnimations = animations;
    galleryTransition = Promise.allSettled(animations.map((animation) => animation.finished)).then(() => {
      outgoing.remove();
      animations.forEach((animation) => animation.cancel());
      galleryAnimations = [];
      hero.classList.remove('is-sliding');
    });
  }

  // Warm the next image in the current direction without blocking interaction.
  const nextIndex = (index + direction + offer.productImages.length) % offer.productImages.length;
  loadGalleryImage(galleryItem(nextIndex).image).catch(() => {});
}

function moveGallery(direction) {
  changeGallery((galleryIndex + direction + offer.productImages.length) % offer.productImages.length, direction);
}

reducedMotion.addEventListener('change', () => {
  if (reducedMotion.matches) galleryAnimations.forEach((animation) => animation.finish());
});

let gallerySwipe = null;
hero.addEventListener('pointerdown', (event) => {
  if (!event.isPrimary || event.pointerType === 'mouse' || event.target.closest('button')) return;
  gallerySwipe = { id: event.pointerId, x: event.clientX, y: event.clientY };
  hero.setPointerCapture(event.pointerId);
});
hero.addEventListener('pointerup', (event) => {
  if (!gallerySwipe || event.pointerId !== gallerySwipe.id) return;
  const dx = event.clientX - gallerySwipe.x;
  const dy = event.clientY - gallerySwipe.y;
  gallerySwipe = null;
  if (Math.abs(dx) > 48 && Math.abs(dx) > Math.abs(dy) * 1.25) moveGallery(dx < 0 ? 1 : -1);
});
hero.addEventListener('pointercancel', () => { gallerySwipe = null; });

$('.product-gallery').addEventListener('keydown', (event) => {
  if (!event.target.closest('button')) return;
  if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
    event.preventDefault();
    moveGallery(event.key === 'ArrowLeft' ? -1 : 1);
  }
});

let stickyFrame = 0;
function updateSticky() {
  stickyFrame = 0;
  sticky.hidden =
    purchaseButton.getBoundingClientRect().bottom > 0 ||
    Boolean($('dialog[open]'));
}
function scheduleSticky() {
  if (!stickyFrame) stickyFrame = requestAnimationFrame(updateSticky);
}

// Native radios keep keyboard navigation and accessible checked state.
document.addEventListener('change', (event) => {
  const input = event.target;
  if (input.matches('input[name="pack"]')) changePack(input.value);
  else if (input.matches('input[name="purchase-type"]')) {
    state.purchaseType = input.value;
    renderOffer();
  } else if (input.id === 'delivery') {
    state.interval = Number(input.value);
    renderOffer();
  }
});

document.addEventListener('click', (event) => {
  const policyLink = event.target.closest('a[href]');
  if (policyLink && new URL(policyLink.href).origin === location.origin &&
    new URL(policyLink.href).hash === '#refund-policy') {
    const policy = $('#refund-policy');
    if (policy) {
      event.preventDefault();
      policy.open = true;
      history.replaceState(null, '', '#refund-policy');
      policy.scrollIntoView({ block: 'start', behavior: 'instant' });
      $('summary', policy).focus({ preventScroll: true });
    }
    return;
  }
  const button = event.target.closest('button');
  if (!button || button.disabled) return;
  if (button.dataset.gallery !== undefined)
    changeGallery(Number(button.dataset.gallery));
  if (button.dataset.guide !== undefined)
    openGuide(Number(button.dataset.guide), button);
  switch (button.dataset.action) {
    case 'gallery-prev':
      moveGallery(-1);
      break;
    case 'gallery-next':
      moveGallery(1);
      break;
    case 'add-to-bag': {
      const next = selection();
      if (shopifyConfig) {
        void updateSavedCart('save', next, button);
        break;
      }
      prepareCart(next); // Local previews do not contact Shopify.
      state.cart = { ...next };
      renderCart();
      openDialog(cartDialog, button);
      break;
    }
    case 'open-bag':
      renderCart();
      openDialog(cartDialog, button);
      void refreshCart();
      break;
    case 'checkout':
      if (state.cart) void updateSavedCart('checkout', { ...state.cart });
      break;
    case 'remove-from-bag':
      if (shopifyConfig) {
        void updateSavedCart('remove');
        break;
      }
      state.cart = null;
      renderCart();
      $('.cart-empty-action').focus();
      break;
    case 'close-dialog':
      button.closest('dialog').close();
      break;
    case 'edit-selection':
      if (state.cart) {
        state.packId = state.cart.packId;
        state.purchaseType = state.cart.purchaseType;
        state.interval = state.cart.intervalDays;
        renderOffer();
      }
      returnToOffer();
      break;
    case 'upgrade-duo':
      changePack('duo');
      break;
    case 'choose-duo':
      state.purchaseType = 'subscription';
      changePack('duo');
      returnToOffer();
      break;
    case 'subscribe':
      state.purchaseType = 'subscription';
      renderOffer();
      returnToOffer();
      break;
  }
});

$$('dialog').forEach((dialog) => {
  let startedOutside = false;
  const isOutside = (event) => {
    const rect = dialog.getBoundingClientRect();
    return (
      event.target === dialog &&
      (event.clientX < rect.left ||
        event.clientX > rect.right ||
        event.clientY < rect.top ||
        event.clientY > rect.bottom)
    );
  };
  dialog.addEventListener('pointerdown', (event) => {
    startedOutside = isOutside(event);
  });
  dialog.addEventListener('click', (event) => {
    if (startedOutside && isOutside(event)) dialog.close();
    startedOutside = false;
  });
  dialog.addEventListener('close', () => {
    const trigger = dialogTriggers.get(dialog);
    if (trigger?.isConnected) trigger.focus({ preventScroll: true });
    scheduleSticky();
  });
});

window.addEventListener('scroll', scheduleSticky, { passive: true });
window.addEventListener('resize', scheduleSticky);
new IntersectionObserver(scheduleSticky).observe(purchaseButton);
new ResizeObserver(scheduleSticky).observe($('.product-section'));
$$('button[disabled]:not(.checkout-unavailable), input[disabled], select[disabled]').forEach((control) => {
  control.disabled = false;
});
initAnnouncement();
renderOffer();
renderCart();
renderReviews();
changeGallery(0);
const revealLinkedPolicy = () => {
  if (location.hash !== '#refund-policy') return;
  const policy = $('#refund-policy');
  if (!policy) return;
  policy.open = true;
  policy.scrollIntoView({ block: 'start', behavior: 'instant' });
};
revealLinkedPolicy();
window.addEventListener('hashchange', revealLinkedPolicy);
void refreshCart();
window.addEventListener('pageshow', event => { if (event.persisted) void refreshCart(); });
document.addEventListener('visibilitychange', () => {
  if (document.visibilityState === 'visible') void refreshCart();
});
